var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-card-content" } },
    [
      _c(
        "w-row",
        [
          _c("w-col", { attrs: { xs: "12" } }, [
            _vm._v(
              _vm._s(
                _vm.printBooleanText(
                  "reminder-sent-via-email",
                  _vm.reminder.IsSentWithEmail
                )
              )
            ),
          ]),
          _c("w-col", { attrs: { xs: "12" } }, [
            _vm._v(
              _vm._s(
                _vm.printBooleanText(
                  "reminder-sent-via-download",
                  _vm.reminder.IsDownloaded
                )
              )
            ),
          ]),
          _c("w-col", { attrs: { xs: "12" } }, [
            _vm._v(
              _vm._s(
                _vm.printBooleanText(
                  "reminder-sent-via-print",
                  _vm.reminder.IsPrinted
                )
              )
            ),
          ]),
        ],
        1
      ),
      _vm.reminder.File
        ? _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-link",
                    {
                      attrs: { disabled: _vm.downloading },
                      on: {
                        click: function ($event) {
                          return _vm.downloadReminder()
                        },
                      },
                    },
                    [
                      _c("w-fa", { attrs: { icon: "download" } }),
                      _vm._v(" " + _vm._s(_vm.fileName)),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }